import React, { useEffect, useState, useMemo } from "react";
import "../../styles/category.css";
import "../../styles/cartpop.css";
import Loader from "../loader/loader";
import { useNavigate } from "react-router-dom";
import { LocalStorageUtils } from "../../utils/localstorage.utils.jsx";
import { CUSTOMER_PRODUCT_POST_TYPE_MAP, EVENT_NAME } from "utils/constants";
import debounce from "lodash.debounce";
import AnalyticsService from "services/analytics.service";
import CustomerProductCard from "./CustomerProductCard";
import OTPVerification from "components/Auth/mobileotp";

export default function CustomerProductListDisplay({
  products,
  postType,
  displayTitle,
  displaySubTitle,
  isLoading,
}) {
  const navigate = useNavigate();

  const [searchQuery, setSearchQuery] = useState("");
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [authToken, setAuthToken] = useState(
    LocalStorageUtils.get(LocalStorageUtils.LOCAL_STORAGE_KEY.AUTH_TOKEN)
  );

  const refreshAuthToken = () => {
    setAuthToken(
      LocalStorageUtils.get(LocalStorageUtils.LOCAL_STORAGE_KEY.AUTH_TOKEN)
    );
  };

  const loginSuccess = async () => {
    refreshAuthToken();
    setShowLoginPopup(false);
    navigate(`/customer-products/${postType}/add`);
    AnalyticsService.trackEvent(EVENT_NAME.CUSTOMER_PRODUCT_ADD_BUTTON_CLICKED, {
      postType: postType,
    });
  };


  // Filter products based on search query
  const filteredProducts = products.filter((product) =>
    product.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const searchQueryChange = (e) => {
    const searchQueryText = e.target.value;
    setSearchQuery(searchQueryText);
    AnalyticsService.trackEvent(EVENT_NAME.SEARCH_PRODUCT, {
      searchQuery: searchQueryText,
      postType: postType,
    });
  };

  const debouncedResults = useMemo(() => {
    return debounce(searchQueryChange, 300);
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <div className="category-page">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{display: "flex", flexDirection: "column", gap: "0px", alignItems: "flex-start"}}>
            <h1 className="category-title" style={{marginBottom: "0px"}}>{displayTitle}</h1>
            <span>{displaySubTitle}</span>
            </div>
            <button
              className="add-product-button"
              onClick={() => {
                if (!authToken) {
                  return setShowLoginPopup(true);
                }
                navigate(`/customer-products/${postType}/add`);
                AnalyticsService.trackEvent(
                  EVENT_NAME.CUSTOMER_PRODUCT_ADD_BUTTON_CLICKED,
                  {
                    postType: postType,
                  }
                );
              }}
            >
              Add {CUSTOMER_PRODUCT_POST_TYPE_MAP.BUTTON_TEXT[postType]}
            </button>
          </div>
          {/*  <div className="search-container">
            <input
              type="text"
              placeholder="Search for products..."
              onChange={debouncedResults}
              className="search-input"
            />
          </div> */}
          <div className="product-list" style={{marginTop: "10px"}}>
            {products.length === 0 && <div>No {CUSTOMER_PRODUCT_POST_TYPE_MAP.BUTTON_TEXT[postType]} found</div>}
            {filteredProducts.map((product) => (
              <CustomerProductCard
                key={product.id}
                product={product}
              />
            ))}
            <div style={{ height: "50vh" }}>.</div>
          </div>
        </div>
      )}
      {showLoginPopup && (
        <OTPVerification
          onSuccess={() => loginSuccess()}
          onClose={() => setShowLoginPopup(false)}
        />
      )}
    </>
  );
}
